export class ExpenseClaimsSearchParams {
  consultantId: number = 0;
  fromDate: Date = null;
  toDate: Date = null;
}

